import axios from "./HttpClient";

import { get, clone } from "lodash";

let localization = {
    welcome: "Welcome",
    completeYourProfile: "Complete your profile",
    registerOrganization: "Register your organization",
    studentRegistration: "Student Registration",
    editProfile: "Update your information",
    update: "Next",
};

let customLocalization = clone(localization);

axios.get(`${IdentityServerUrl}static/branding/content`, { withCredentials: true, params: { locale: navigator.language.substring(0, 2) } }).then((response) => {
    customLocalization = response.data;
});

type localizationType = "welcome" | "completeYourProfile" | "registerOrganization" | "studentRegistration" | "editProfile" | "update";

export default function localize(key: localizationType) {
    return get(customLocalization, key, get(localization, key, ""));
}

export const HelpText1 = `**Use your brilliant mind to code a greener future in the UNISA Code the Climate Hackathon!**

Can you harness the power of technology to tackle real-world environmental challenges?
 
**Calling Everyone!**
 
Do you have what it takes to solve climate issues with creativity and practical innovation?
Join the UNISA Code the Climate Hackathon and showcase your skills by developing a solution to one of South Africa's pressing sustainability challenges.
 
Submit your ideas and stand a chance to present your solution at the prestigious Global Voices Climate Change Summit.
Your work will be judged by a panel of experts, and the top entries will be invited to share their vision for a better South Africa on a national stage.
 `;

export const HelpText2 = `**The Journey**
 
As you develop your hack, you'll have access to powerful AI tools from Microsoft Azure for Students and other cutting-edge resources.
You have until 12 September 2025 at 12:00 PM to submit your entry. The top 3 students will present at the summit. Winners will be announced at the closing of the summit on the 25th of September 2025.
 
**Let the Hacks Begin!**
 
Unleash your potential, innovate for impact, and be part of the movement to build a sustainable future.
We can't wait to see how you'll code the climate!`;

export const HelpText = HelpText1 + HelpText2;

export const RulesText = `**Participants**: Everyone over 18  
If you are a UNISA student please sign in with your UNISA email address

You can enter as an individual or as a team of up to 4 people. If you are entering as a team, please ensure that all members submit the same hack.

Get Ready for an Exhilarating Journey of Innovation and Creativity!
 
Participants will embark on an eco-innovative adventure :
 
Submit your innovative climate-focused hack using the official template provided. Your solution should creatively address one of South Africa's sustainability challenges.
 
Top 3 will be invited to present their groundbreaking projects at the Global Voices Climate Change Summit.
 
The Stakes Are High
 
The top 3 students will walk away with  prizes, celebrating their exceptional achievements and contributions to a greener future.
 
Let the Hacking Begin!
 
Unleash your creativity, harness the power of AI, and be part of the movement to Code the Climate.
We can't wait to see your vision for a sustainable South Africa!`;
